import CountryBreakdownChart from 'components/InvestmentAnalyser/CountryBreakdownChart';
import React, { useRef } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import ReportChart from './Chart';

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      width: '600px',
      maxWidth: '600px'
    },
    gridBox: {
      display: 'flex',
      flexDirection: 'column',
      padding: '1rem',
      border: '1px solid #e5dede'
    },
    chartBox: {
      height: '100%',
      padding: '2rem 0'
    }
  })
);

const CountryBreakdown = ({ name, data }: any) => {
  const chart = useRef(null);
  const classes = useStyles();

  return (
    <ReportChart
      name={name || 's_asset_p03_allocation_00'}
      chartElement={chart.current}
    >
      <Grid item xs={12} sm={8} md={8} lg={8} className={classes.wrapper}>
        <Paper className={classes.gridBox}>
          <Grid item xs={12} className={classes.chartBox} ref={chart}>
            <CountryBreakdownChart data={data} isForReport />
          </Grid>
        </Paper>
      </Grid>
    </ReportChart>
  );
};

export default CountryBreakdown;
